import React, { Fragment } from 'react'
import cn from 'classnames'
import { Paper, Table } from '@material-ui/core'

import { BlacklistBookings } from "../BlacklistBookings";
import { BookingsTableHead, BookingsTableBody } from './components'

const columnData = [
  { id: 'serial', label: '#' },
  { id: 'from', label: 'Звідки' },
  { id: 'to', label: 'Куди' },
  { id: 'surname', label: 'Прізвище' },
  { id: 'name', label: 'Імя' },
  { id: 'phone', label: 'Телефон' },
  { id: 'price', label: 'Ціна' },
  { id: 'note', label: 'Відмітка' },
  { id: 'place', label: 'Місце' },
]

export const BookingsBase = ({
  classes, requestSortHandler, onSortResetClickHandler,
  order, orderBy, bookingsWithoutBlacklist, blacklistPageBookings, isDisabled, hideBlacklist
}) => {

  return (
    <Fragment>
      <Paper className={cn(classes.container, isDisabled && classes.disabled)}>
        <Table>
          <BookingsTableHead
            order={order}
            padding='none'
            orderBy={orderBy}
            columnData={columnData}
            requestSort={requestSortHandler}
            onSortResetClick={onSortResetClickHandler}
          />
          <BookingsTableBody
            order={order}
            orderBy={orderBy}
            bookings={bookingsWithoutBlacklist}
          />
        </Table>
      </Paper>
      {!hideBlacklist && !!blacklistPageBookings.length && (
        <Paper>
          <BlacklistBookings blacklistPageBookings={blacklistPageBookings} />
        </Paper>
      )}
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/Bookings/Bookings.js